import { BORDER_COLORS } from "../../../../../components/Charts/constants";
import { byNumber, formatDate, sortRows, SortRule } from "../../../../../utils";
import { DateFormat } from "../../../../../utils/types";
import { LiabilitiesObject } from "../../../types";
import { LiabilityRow, SortKey, SortState } from "./types";

// principalAmount is the principal paid so far, so this mirrors the payoff percent in the hero donut.
const getPaidOffPercent = (liability: LiabilitiesObject): number => {
  if (liability.amountLent <= 0) {
    return 0;
  }
  return (liability.principalAmount / liability.amountLent) * 100;
};

const getEndYear = (endDate: string): number | null => {
  const year = new Date(endDate).getFullYear();
  return Number.isNaN(year) ? null : year;
};

export const buildLiabilitiesHoldings = (
  liabilities: LiabilitiesObject[],
): LiabilityRow[] => {
  return liabilities.map((liability, index) => {
    return {
      id: liability.id,
      name: liability.name,
      typeLabel: liability.liabilityTypeName,
      typeColor: BORDER_COLORS[index % BORDER_COLORS.length],
      rate: liability.interestRate ?? null,
      started: formatDate(liability.startDate, DateFormat.DMY_SPACE),
      startedValue: new Date(liability.startDate).getTime(),
      debt: liability.currentAmount,
      paid: liability.paidAmount,
      lent: liability.amountLent,
      progress: getPaidOffPercent(liability),
      endYear: getEndYear(liability.endDate),
      endValue: new Date(liability.endDate).getTime(),
    };
  });
};

const SORT_RULES: Record<SortKey, SortRule<LiabilityRow>> = {
  rate: byNumber((row) => row.rate),
  started: byNumber((row) => row.startedValue),
  debt: byNumber((row) => row.debt),
  paid: byNumber((row) => row.paid),
  progress: byNumber((row) => row.progress),
  ends: byNumber((row) => row.endValue),
};

export const sortLiabilities = (
  rows: LiabilityRow[],
  sort: SortState,
): LiabilityRow[] => sortRows(rows, SORT_RULES, sort);
